import { render, staticRenderFns } from "./Nav-tabs.vue?vue&type=template&id=45ca7b38"
import script from "./Nav-tabs.vue?vue&type=script&lang=js"
export * from "./Nav-tabs.vue?vue&type=script&lang=js"
import style0 from "./Nav-tabs.vue?vue&type=style&index=0&id=45ca7b38&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsItems } from 'vuetify/lib/components/VTabs';
installComponents(component, {VRow,VTab,VTabItem,VTabs,VTabsItems})
